import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core'
import { ActivatedRoute, IsActiveMatchOptions, NavigationEnd, Router } from '@angular/router'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { GbNavigationService } from 'libs/shared/utils/services/src/lib/gb-navigation-service/gb-navigation.service'
import { filter } from 'rxjs'

@UntilDestroy()
@Directive({
  selector: '[gbRouteNewTab]',
})
export class GbRouteNewTabDirective {
  @Input() gbRouteNewTab: string | null | undefined | Array<string | undefined>
  @Input() activeLinkClass: string = 'is-active'
  @Input() params?: {} = {}

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private gbNavigationService: GbNavigationService,
  ) {}

  matchOptions: IsActiveMatchOptions = {
    matrixParams: 'ignored',
    queryParams: 'ignored',
    paths: 'subset',
    fragment: 'ignored',
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (
      typeof this.gbRouteNewTab === 'string' ||
      (Array.isArray(this.gbRouteNewTab) && this.gbRouteNewTab.every((item) => typeof item === 'string'))
    ) {
      return this.gbNavigationService.navigate(this.gbRouteNewTab as string | string[], {
        activatedRoute: this.activatedRoute,
        newTab: event.ctrlKey || event.metaKey,
        params: this.params,
      })
    }
  }

  ngOnChanges() {
    this.updateActiveClass()
  }

  ngOnInit() {
    this.router.events
      .pipe(
        untilDestroyed(this),
        filter((event) => event instanceof NavigationEnd),
      )
      .subscribe(() => {
        this.updateActiveClass()
      })
  }

  getIsActive(): boolean {
    if (this.gbRouteNewTab) {
      let routeArray: Array<string | undefined> = []

      if (this.gbRouteNewTab instanceof Array) {
        routeArray = this.gbRouteNewTab
      } else {
        if (this.router.isActive(this.gbRouteNewTab, this.matchOptions)) {
          return true
        }
        // if we need to change the match options to also check the query params then
        // update here to split by '/' (based on the input etc.)
        // below is to ignore the query params
        routeArray = this.gbRouteNewTab.split(/[/?]/)
      }

      const currentRouteArray = this.router.url.split(/[/?]/)
      const finalRoute = routeArray[routeArray.length - 1]

      if (finalRoute) return currentRouteArray.includes(finalRoute)
    }

    return false
  }

  updateActiveClass() {
    let isActive = false

    if (this.gbRouteNewTab) {
      isActive = this.getIsActive()
    }

    if (isActive) {
      this.renderer.addClass(this.elementRef.nativeElement, this.activeLinkClass)
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, this.activeLinkClass)
    }
  }
}
